/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UpdateDocumentContactResponseData,
  UpdateDocumentContactResponseDataFromJSON,
  UpdateDocumentContactResponseDataFromJSONTyped,
  UpdateDocumentContactResponseDataToJSON
} from './UpdateDocumentContactResponseData'

/**
 *
 * @export
 * @interface UpdateDocumentContactResponse
 */
export interface UpdateDocumentContactResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateDocumentContactResponse
   */
  status?: number
  /**
   *
   * @type {UpdateDocumentContactResponseData}
   * @memberof UpdateDocumentContactResponse
   */
  data?: UpdateDocumentContactResponseData
}

export function UpdateDocumentContactResponseFromJSON(json: any): UpdateDocumentContactResponse {
  return UpdateDocumentContactResponseFromJSONTyped(json, false)
}

export function UpdateDocumentContactResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateDocumentContactResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : UpdateDocumentContactResponseDataFromJSON(json['data'])
  }
}

export function UpdateDocumentContactResponseToJSON(value?: UpdateDocumentContactResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: UpdateDocumentContactResponseDataToJSON(value.data)
  }
}
